// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__PbuPX","notes":"Notes_notes__b5-l4","note":"Notes_note__1peAK","markdown":"Notes_markdown__2dbYJ"};